type NavigationLinkImage = {
  title: string
  url: string
  linkTo: string
}

type LinkObject = {
  title: string
  url: string
}

export type NavigationLinksObject = {
  title: string
  links: ReadonlyArray<LinkObject>
}

export type NavigationLinksCategories = {
  title: string
  url: string
  highlighted?: boolean
  feature: ReadonlyArray<NavigationLinkImage>
  links: ReadonlyArray<NavigationLinksObject>
}

export const NavigationLinks: ReadonlyArray<NavigationLinksCategories> = [
  {
    title: 'Paintings',
    url: '/paintings',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-paintings-v4.jpg',
        title: 'Featured Paintings',
        linkTo:
          'https://www.saatchiart.com/art-collection/painting/Featured-Paintings/1586325/856183/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/paintings-abstracts.jpg',
        title: 'Best of Abstracts',
        linkTo: 'https://www.saatchiart.com/art-collection/Best-of-Abstracts/2131451/861229/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/paintings-landscapes.jpg',
        title: 'Best of Landscapes',
        linkTo: 'https://www.saatchiart.com/art-collection/Best-of-Landscapes/1861756/861111/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Fine Art',
            url: '/paintings/fine-art',
          },
          {
            title: 'Abstract',
            url: '/paintings/abstract',
          },
          {
            title: 'Modern',
            url: '/paintings/modern',
          },
          {
            title: 'Street Art',
            url: '/paintings/street-art',
          },
          {
            title: 'Pop Art',
            url: '/paintings/pop-art',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Portrait',
            url: '/paintings/portrait',
          },
          {
            title: 'Landscape',
            url: '/paintings/landscape',
          },
          {
            title: 'Still Life',
            url: '/paintings/still-life',
          },
          {
            title: 'Nature',
            url: '/paintings/nature',
          },
          {
            title: 'Beach',
            url: '/paintings/beach',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Oil',
            url: '/paintings/oil',
          },
          {
            title: 'Watercolor',
            url: '/paintings/watercolor',
          },
          {
            title: 'Acrylic',
            url: '/paintings/acrylic',
          },
          {
            title: 'Airbrush',
            url: '/paintings/airbrush',
          },
          {
            title: 'Ink',
            url: '/paintings/ink',
          },
        ],
      },
    ],
  },
  {
    title: 'Photography',
    url: '/photography',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-photography-v4.jpg',
        title: 'Featured Photography',
        linkTo:
          'https://www.saatchiart.com/art-collection/Featured-Photography/2131451/856313/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Fine Art',
            url: '/photography/fine-art',
          },
          {
            title: 'Portraiture',
            url: '/photography/portraiture',
          },
          {
            title: 'Abstract',
            url: '/photography/abstract',
          },
          {
            title: 'Documentary',
            url: '/photography/documentary',
          },
          {
            title: 'Conceptual',
            url: '/photography/conceptual',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Landscape',
            url: '/photography/landscape',
          },
          {
            title: 'Portrait',
            url: '/photography/portrait',
          },
          {
            title: 'Nature',
            url: '/photography/nature',
          },
          {
            title: 'Still Life',
            url: '/photography/still-life',
          },
          {
            title: 'Nude',
            url: '/photography/nude',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Digital',
            url: '/photography/digital',
          },
          {
            title: 'Black and White',
            url: '/photography/black-white',
          },
          {
            title: 'Color',
            url: '/photography/color',
          },
          {
            title: 'C-type',
            url: '/photography/c-type',
          },
          {
            title: 'Giclée',
            url: '/photography/giclee',
          },
        ],
      },
    ],
  },
  {
    title: 'Sculpture',
    url: '/sculpture',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-sculpture-v4.jpg',
        title: 'Featured Sculptures',
        linkTo:
          'https://www.saatchiart.com/art-collection/sculpture-painting/Featured-Sculptures/1861756/726057/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/sculpt-outdoorsculpt.jpg',
        title: 'Best of Outdoor Sculpture',
        linkTo:
          'https://www.saatchiart.com/art-collection/Best-of-Outdoor-Sculptures/1586325/860321/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Pop Art',
            url: '/sculpture/pop-art',
          },
          {
            title: 'Abstract',
            url: '/sculpture/abstract',
          },
          {
            title: 'Wall',
            url: '/sculpture/wall',
          },
          {
            title: 'Figurative',
            url: '/sculpture/figurative',
          },
          {
            title: 'Modern',
            url: '/sculpture/modern',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Body',
            url: '/sculpture/body',
          },
          {
            title: 'Still Life',
            url: '/sculpture/still-life',
          },
          {
            title: 'Animal',
            url: '/sculpture/animal',
          },
          {
            title: 'Architecture',
            url: '/sculpture/architecture',
          },
          {
            title: 'Geometric',
            url: '/sculpture/geometric',
          },
        ],
      },
      {
        title: 'Method',
        links: [
          {
            title: '3D Sculpting',
            url: '/sculpture/3d-sculpting',
          },
          {
            title: 'Assemblage',
            url: '/sculpture/assemblage',
          },
          {
            title: 'Modeling',
            url: '/sculpture/modeling',
          },
          {
            title: 'Carving',
            url: '/sculpture/carving',
          },
          {
            title: 'Casting',
            url: '/sculpture/casting',
          },
        ],
      },
    ],
  },
  {
    title: 'Drawings',
    url: '/drawings',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-drawing-v4.jpg',
        title: 'Featured Drawings',
        linkTo: 'https://www.saatchiart.com/art-collection/Featured-Drawings/1754780/854095/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Graffiti',
            url: '/drawings/graffiti',
          },
          {
            title: 'Abstract',
            url: '/drawings/abstract',
          },
          {
            title: 'Fine Art',
            url: '/drawings/fine-art',
          },
          {
            title: 'Pop Art',
            url: '/drawings/pop-art',
          },
          {
            title: 'Surrealism Art',
            url: '/drawings/surrealism',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Nature',
            url: '/drawings/nature',
          },
          {
            title: 'Portrait',
            url: '/drawings/portrait',
          },
          {
            title: 'Animal',
            url: '/drawings/animal',
          },
          {
            title: 'Love',
            url: '/drawings/love',
          },
          {
            title: 'Cartoon',
            url: '/drawings/cartoon',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Pencil',
            url: '/drawings/pencil',
          },
          {
            title: 'Charcoal',
            url: '/drawings/charcoal',
          },
          {
            title: 'Digital',
            url: '/drawings/digital',
          },
          {
            title: 'Ink',
            url: '/drawings/ink',
          },
          {
            title: 'Pastel',
            url: '/drawings/pastel',
          },
        ],
      },
    ],
  },
  {
    title: 'Prints',
    url: '/prints',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-prints-v4.jpg',
        title: 'Fine Art Prints',
        linkTo: 'https://www.saatchiart.com/stories/fine-art-prints',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-art-prints-v4.jpg',
        title: 'Featured Art Prints',
        linkTo: 'https://www.saatchiart.com/art-collection/Featured-Prints/1754780/857921/view ',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Fine Art',
            url: '/prints/fine-art',
          },
          {
            title: 'Abstract',
            url: '/prints/abstract',
          },
          {
            title: 'Art Deco',
            url: '/prints/art-deco',
          },
          {
            title: 'Pop Art',
            url: '/prints/pop-art',
          },
          {
            title: 'Folk Art',
            url: '/prints/folk',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Floral',
            url: '/prints/floral',
          },
          {
            title: 'Animal',
            url: '/prints/animal',
          },
          {
            title: 'Fashion',
            url: '/prints/fashion',
          },
          {
            title: 'Beach',
            url: '/prints/beach',
          },
          {
            title: 'Geometric',
            url: '/prints/geometric',
          },
        ],
      },
      {
        title: 'Material',
        links: [
          {
            title: 'Fine Art Paper',
            url: '/prints?prints_materials=rag',
          },
          {
            title: 'Photo Paper',
            url: '/prints?prints_materials=photo',
          },
          {
            title: 'Canvas',
            url: '/prints?prints_materials=canvas',
          },
          {
            title: 'Metal',
            url: '/prints?prints_materials=metal',
          },
          {
            title: 'Acrylic',
            url: '/prints?prints_materials=acrylic',
          },
        ],
      },
    ],
  },
  {
    title: 'Inspiration',
    url: '/stories',
    feature: [
      {
        title: 'Anniversary Collections',
        url:
          'https://images.saatchiart.com/saatchi-general/homepage/anniversaryImages/anniversary-coolections.jpg',
        linkTo: 'https://www.saatchiart.com/stories/15yearsofart',
      },
      {
        title: 'Top-Selling Artists',
        url:
          'https://images.saatchiart.com/saatchi-general/homepage/anniversaryImages/top-sellers.jpg',
        linkTo:
          'https://www.saatchiart.com/art-collection/painting-photography-mixed-media/Collector-Favorites/1586325/872705/view',
      },
      {
        title: 'Best of Rising Stars',
        url:
          'https://images.saatchiart.com/saatchi-general/homepage/anniversaryImages/rising-stars.jpg',
        linkTo:
          'https://www.saatchiart.com/art-collection/Best-of-Rising-Stars/1754780/872853/view',
      },
    ],
    links: [
      {
        title: '',
        links: [
          {
            title: 'Curated Collections',
            url: '/collections/featured',
          },
          {
            title: 'Digital Exhibitions',
            url: '/shows',
          },
          {
            title: 'Catalog',
            url: '/catalog',
          },
          {
            title: 'Art Stories',
            url: '/stories',
          },
          {
            title: 'Trending Artists',
            url: '/trendingartists',
          },
          {
            title: 'Living With Art',
            url: '/livingwithart',
          },
        ],
      },
      {
        title: '',
        links: [
          {
            title: 'Rising Stars',
            url: '/risingstars',
          },
          {
            title: 'The Other Art Fair',
            url: '/theotherartfair',
          },
          {
            title: 'Art Match',
            url: '/artmatch',
          },
          {
            title: 'Art Style Quiz',
            url: '/quiz/art-for-your-style-quiz ',
          },
          {
            title: 'Blog',
            url: '//canvas.saatchiart.com/',
          },
        ],
      },
    ],
  },
  {
    title: 'Art Advisory',
    url: '/artadvisory',
    feature: [
      {
        title: 'How To Buy Art You Love',
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-art-advisory-v4.jpg',
        linkTo: '/stories/how-to-find-the-perfect-artwork',
      },
    ],
    links: [
      {
        title: '',
        links: [
          { title: 'About Art Advisory', url: '/artadvisory' },
          { title: 'Meet The Experts', url: '/artadvisory#team' },
          { title: 'Commission An Artwork', url: '/commissions' },
          { title: 'Contact Art Advisors', url: '/artadvisory/brief' },
        ],
      },
    ],
  },
  {
    title: 'Trade',
    url: '/trade',
    feature: [
      {
        title: 'Trade Program',
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-trade-v4.jpg',
        linkTo: '/trade/trade-program',
      },
    ],
    links: [
      {
        title: '',
        links: [
          {
            title: 'Saatchi Art For Business ',
            url: '/trade',
          },
          {
            title: 'Trade Program',
            url: '/trade/trade-program',
          },
          {
            title: 'Hospitality',
            url: '/trade/hospitality',
          },
          {
            title: 'Contact Art Consultants',
            url: '/trade-hospitality#contact',
          },
        ],
      },
    ],
  },
  {
    title: 'Curated Deals',
    url: '/curated-deals',
    feature: [
      {
        title: '',
        url: '',
        linkTo: '',
      },
    ],
    links: [],
  },
  {
    title: 'Anniversary Picks',
    url: '/stories/15yearsofart',
    feature: [
      {
        title: '',
        url: '',
        linkTo: '',
      },
    ],
    links: [],
  },
]
